import React from "react";
import Header from "../sharedScreens/Header";
import SideMenu from "../sharedScreens/menuItems/SideMenu";
import MuiSearchSelect from "../components/basicComponent/MuiSearchSelect";
import MuiButton from "../components/basicComponent/MuiButton";
import MuiDatePicker from "../components/basicComponent/MuiDatePicker";
import { MuiInput } from "../components/basicComponent/MuiInput";
import UserListFilter from "../components/composite/UserListFilter";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
const CustomerManagement = () => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const CMFilterPopUp = () => {
    return (
      <>
        <form>
          <div className="row mt-4">
            <div className="col-md-4">
             <MuiInput label={"First Name"} placeholder="First Name"/>
            </div>
            <div className="col-md-4">
            <MuiInput label={"Last Name"} placeholder="Last Name"/>
            </div>
            <div className="col-md-4 ">
              <MuiInput label={"Mobile No"} placeholder="Mobile No"/>
            </div>
            <div className="col-md-4 mt-3">
            <MuiInput label={"Alternate Mobile No."} placeholder="Alternate Mobile No."/>
            </div>
            <div className="col-md-4 mt-3   ">
            <MuiInput label={"Email ID"} placeholder="Email ID"/>
            </div>
            <div className="col-md-4 mt-3">
            <MuiInput label={"Password"} placeholder="Password"/>
            </div>
            <div className="col-md-4 mt-3">
              <MuiDatePicker
                label="Date Of Bitrh"
                value={null}
                onChange={function (date: string): void {
                  throw new Error("Function not implemented.");
                }}
              />
            </div>
            <div className="col-md-6 mt-3">
                <h6>Payment Mode</h6>
            <FormControlLabel value="Wallet" control={<Radio />} label="Wallet" />
            <FormControlLabel value="Payment Gateway" control={<Radio />} label="Payment Gateway" />

            </div>
          </div>

          <div className="user-button w-full pt-3">
            <MuiButton className="clear-btn" label="Clear" type="submit" />
            <MuiButton className="get-btn" label="Add Customer" type="submit" />
          </div>
        </form>
      </>
    );
  };
  return (
    <div className="grow">
      <SideMenu />
      <div className="wrapper flex grow flex-col">
        <Header />
        <main className="grow content" id="content" role="content">
          <div className="container-fixed">
            <div className="card-header text-center">
              <h3 className="card-title">Customer Management</h3>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card card-custom">
                  <div className="card-body">
                    <div className="row mt-4">
                      <div className="col-md-4">
                        <MuiSearchSelect
                          label={"Search By  "}
                          placeholder="Search By "
                          options={[]}
                          onChange={function (
                            value: string,
                            id: string,
                            data: any
                          ): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>
                      <div className="col-md-4">
                        <MuiSearchSelect
                          label={"Search "}
                          placeholder="Search"
                          options={[]}
                          onChange={function (
                            value: string,
                            id: string,
                            data: any
                          ): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>
                      <div className="col-md-4 ">
                        <MuiDatePicker
                          label="Joined From Date"
                          value={null}
                          onChange={function (date: string): void {
                            throw new Error("Function not implemented.");
                          }}
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiDatePicker
                          label="Joined To Date"
                          value={null}
                          onChange={function (date: string): void {
                            throw new Error("Function not implemented.");
                          }}
                        />
                      </div>
                      <div className="col-md-3 mt-4">
                        <button
                          onClick={handleOpen}
                          className="btn btn-success"
                        >
                          {" "}
                          Add Customer
                        </button>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          gap: "10px",
                          marginTop: "8px",
                        }}
                      >
                        <div className="user-button w-full">
                          <MuiButton
                            label={"Get"}
                            className="main-btn get-btn"
                            variant="contained"
                            size="large"
                            type="submit"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
        {/*-----------------pop code----------------------------  */}
        <UserListFilter
          header={"New Profile"}
          children={<CMFilterPopUp />}
          isVisible={open}
          handleClose={() => handleClose()}
        />
      </div>
    </div>
  );
};

export default CustomerManagement;
